
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/growth-engines",
      function () {
        return require("private-next-pages/us/growth-engines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/growth-engines"])
      });
    }
  